import {pluralize} from '../../utils';

/**
 * @param {Array}  days         všetky dni mesiaca tak, ako ich vrátil kalendár
 * @param {Array}  selectedDays dátumy (Y-m-d) označených dní
 * @param {String} action       'fill' | 'delete'
 * @param {String} mode         'reality' | 'plan'
 * @param {Object} trans        preklady z admin.attendance.bulk
 * @returns {{lines: Array, eligible: Array, hasEligible: Boolean}}
 */
export function computeBatchImpact(days, selectedDays, action, mode, trans) {
    const selection = days.filter(day => selectedDays.indexOf(day.date) !== -1);

    const outsideContract = selection.filter(day => day.isOutsideContract);

    const locked = selection.filter(day => !day.isOutsideContract && day.isLocked);

    const eligible = selection.filter(day => outsideContract.indexOf(day) === -1 && locked.indexOf(day) === -1);

    const hasExistingRecord = mode === 'plan'
        ? eligible.filter(day => day.shiftPlan && day.shiftPlan.id)
        : eligible.filter(day => day.workDay && day.workDay.intervals && day.workDay.intervals.length);

    let holidays = [];
    if (mode === 'reality') {
        holidays = action === 'delete'
            ? hasExistingRecord.filter(day => day.isOffday)
            : eligible.filter(day => day.isOffday);
    }

    const lines = [];

    if (!eligible.length) {
        return {
            lines: [{level: 'danger', text: trans.summary_nothing}],
            eligible: [],
            hasEligible: false
        };
    }

    if (action === 'delete') {
        lines.push({level: 'info', text: pluralize(trans.summary_delete, eligible.length)});
    } else {
        lines.push({level: 'info', text: pluralize(trans.summary_fill, eligible.length)});

        if (hasExistingRecord.length) {
            lines.push({level: 'warning', text: pluralize(trans.summary_overwrite, hasExistingRecord.length)});
        }
    }

    if (locked.length) {
        lines.push({level: 'warning', text: pluralize(trans.summary_skipped_locked, locked.length)});
    }

    if (outsideContract.length) {
        lines.push({level: 'warning', text: pluralize(trans.summary_skipped_contract, outsideContract.length)});
    }

    if (holidays.length) {
        const template = action === 'delete' ? trans.summary_holiday_remove : trans.summary_holiday_create;
        lines.push({level: 'danger', text: pluralize(template, holidays.length)});
    }

    return {lines: lines, eligible: eligible, hasEligible: true};
}

export function batchImpactHtml(impact, trans) {
    const items = impact.lines.map(line => {
        const style = line.level === 'danger'
            ? 'color:#c2183f;font-weight:700;'
            : (line.level === 'warning' ? 'color:#9a5b00;font-weight:600;' : 'color:#43484f;');

        const icon = line.level === 'danger'
            ? 'fa-exclamation-circle'
            : (line.level === 'warning' ? 'fa-exclamation-triangle' : 'fa-check-circle');

        const iconColor = line.level === 'danger'
            ? '#FE3F61'
            : (line.level === 'warning' ? '#E0870F' : '#60CF7D');

        return '<li style="' + style + 'display:flex;align-items:flex-start;padding:2px 0;list-style:none;">'
            + '<i class="fas fa-fw ' + icon + ' mr-2" style="margin-top:3px;color:' + iconColor + ';"></i>'
            + '<span>' + escapeHtml(line.text) + '</span>'
            + '</li>';
    }).join('');

    return '<div style="font-weight:600;color:#43484f;margin-bottom:6px;">'
        + escapeHtml(trans.summary_title) + ':'
        + '</div>'
        + '<ul style="padding:0;margin:0;">' + items + '</ul>';
}

function escapeHtml(text) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(text == null ? '' : text));

    return div.innerHTML;
}



// WEBPACK FOOTER //
// ./resources/assets/admin/js/attendance/show/batchImpact.js